/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {adminGetHistoricalBalances} from '../api'

export const useMutationAdminGetHistoricalBalances = createReactQueryMutationHook('adminGetHistoricalBalances', adminGetHistoricalBalances)
